module.exports = __webpack_public_path__ + "static/img/6.60bb3fc7.png";